import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ViolationRule } from 'src/app/models/api/governance/violationRule.model';
import { GovernanceRulesFiltersResponse } from 'src/app/models/api/governance/governance-rules-filters.model';
import { HttpService } from '../../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class DetectionRulesHttpService {
  private readonly _baseUrl: string = 'governance';

  constructor(@Inject(HttpService) private readonly _httpService: HttpService) {}

  public getDetectionRules(integrationId: string): Observable<ViolationRule[]> {
    const url = `${this._baseUrl}/policies/integration/${integrationId}/detectionRules`;
    return this._httpService.get<ViolationRule[]>(url);
  }

  public getRulesFilters(integrationId: string, policyId: string): Observable<GovernanceRulesFiltersResponse> {
    const url = `${this._baseUrl}/policies/integration/${integrationId}/policy/${policyId}/rules/filters`;
    return this._httpService.get<GovernanceRulesFiltersResponse>(url);
  }
}
